import { takeEvery, put } from 'redux-saga/effects';
import { assignTasksTo, unassignTasks, setChannelWorkflowLoadingOverlayState, assignPostAcqTasksTo, unassignPostAcqTasks, setPostAcqWorkflowLoadingOverlayState, appNotify } from 'store/actions';
import { putWithTokenV2 } from 'api/network';

export function* taskAssignmentSaga() {
  yield takeEvery([assignTasksTo, assignPostAcqTasksTo], function* ({ type, payload }) {
    const isPostAcq = type === 'postAcqWorkflowSlice/assignPostAcqTasksTo';
    const loadingAction = isPostAcq ? setPostAcqWorkflowLoadingOverlayState : setChannelWorkflowLoadingOverlayState;
    const assignUrl = isPostAcq ? '/api/postAcquisition/tasks/assign' : '/api/underwrite/workflow/tasks/assign';
    const { taskType, taskIds, assignToUserId, initiatedUserId } = payload;
    console.log(type)
    try {
      yield put(loadingAction({ isLoading: true, message: 'Assigning task...' }));
      yield putWithTokenV2(assignUrl, { taskType, taskIds, assignToUserId, initiatedUserId })

      yield put(loadingAction({ isLoading: false, message: null }));
      yield put(appNotify('Assigned', 'success'));
    } catch (error) {
      yield put(loadingAction({ isLoading: false, message: null }));
      yield put(appNotify(error.message, 'error'));
    }
  });

  yield takeEvery([unassignTasks, unassignPostAcqTasks], function* ({ type, payload }) {
    const isPostAcq = type === 'postAcqWorkflowSlice/unassignPostAcqTasks';
    const loadingAction = isPostAcq ? setPostAcqWorkflowLoadingOverlayState : setChannelWorkflowLoadingOverlayState;
    const unassignUrl = isPostAcq ? '/api/postAcquisition/tasks/unassign' : '/api/underwrite/workflow/tasks/unassign';
    const { taskType, taskIds, initiatedUserId } = payload;
    try {
      yield put(loadingAction({ isLoading: true, message: 'Unassigning task...' }));
      yield putWithTokenV2(unassignUrl, { taskType, taskIds, initiatedUserId })

      yield put(loadingAction({ isLoading: false, message: null }));
      yield put(appNotify('Unassigned', 'success'));
    } catch (error) {
      yield put(loadingAction({ isLoading: false, message: null }));
      yield put(appNotify(error.message, 'error'));
    }
  });
}
